import React from "react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { TID } from "@/constants/testIds";

export default function KpiCard({ name, label, value, delta, deltaLabel, icon: Icon, tone = "default" }) {
  const positive = delta != null && delta >= 0;
  return (
    <div data-testid={TID.kpi(name)} className="card-elevated p-5 lg:p-6 relative overflow-hidden">
      <div className="flex items-start justify-between">
        <div className="text-overline">{label}</div>
        {Icon ? (
          <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${tone === "accent" ? "bg-accent/10 text-accent" : "bg-primary/5 text-primary"}`}>
            <Icon className="h-4 w-4" />
          </div>
        ) : null}
      </div>
      <div className="mt-3 font-heading text-3xl lg:text-[2rem] font-semibold tracking-tight text-foreground">
        {value}
      </div>
      {delta != null && (
        <div className={`mt-2 inline-flex items-center gap-1 text-sm ${positive ? "text-emerald-700" : "text-red-700"}`}>
          {positive ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />}
          <span className="font-medium">{positive ? "+" : ""}{delta}%</span>
          {deltaLabel ? <span className="text-muted-foreground">· {deltaLabel}</span> : null}
        </div>
      )}
    </div>
  );
}
